import { render, staticRenderFns } from "./MinimumWageTable.vue?vue&type=template&id=2e5b73ea&scoped=true"
import script from "./MinimumWageTable.vue?vue&type=script&lang=js"
export * from "./MinimumWageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b73ea",
  null
  
)

export default component.exports